<template>
<!--
  Local URL: http://localhost:8080/submit-vectraits
  Required Group Membership: Uploader, Curator or Admin
  Purpose: This page is for members of the Uploaders group to upload a file for ingestion into the database. Once the 
  file is uploaded, the user will see any errors preventing the file from being ingested. If the file is successful, 
  the user will see a summary of the data as the system sees it. If it looks the way that they expect, they can
  'confirm' the upload which will let a curator know that there is a file ready to be curated.
-->
  <VTBaseTemplate>
    <b-modal
      id="api-err-modal"
      v-model="apiErrModalShow"
      centered
      scrollable
      hide-footer
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      title="Error"
      :header-bg-variant="'warning'"
      :header-text-variant="'light'">
      <span v-html="err_msg"></span>
      <b-button class="mt-3" block @click="hideModal">OK</b-button>
    </b-modal>

    <!-- This modal shows when a user cancels a file upload -->
    <b-modal
      id="-upload-cancel-modal"
      v-model="uploadCancelModal"
      centered
      scrollable
      hide-footer
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      title="Cancel File Upload"
      :header-bg-variant="'warning'"
      :header-text-variant="'light'">
      <span v-html="err_msg"></span>
      <b-button class="mt-3" block @click="hideModal">Back</b-button>
      <b-button class="mt-3" variant="danger" block @click="cancelFileUpload">Cancel File Upload</b-button>
    </b-modal>

    <!-- This modal shows while the file is updated and processed. -->
    <b-modal
      id="warning-modal"
      v-model="workingModalShow"
      centered
      scrollable
      hide-footer
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      title="Processing File"
      :header-bg-variant="'warning'"
      :header-text-variant="'light'">
      <span v-html="'Please wait while the file is processed. This may take several minutes.'"></span>
    </b-modal>
    <br><br><br>
    <div class="w-100 h-100">
      <b-container fluid>
        <br><br><br>
        <h2 class="tw-mb-0 text-aegis-dk">Submit VecTraits Data</h2>
        <p class="tw-italic tw-text-gray-700">
          Upload VecTraits data for processing.
        </p>
          <SubmitInstructions />
          <b-button variant="primary" class="ml-1" @click="downloadTemplate">Download Template</b-button>
        </b-container>
        <hr />
        <!-- UPLOAD FORM SECTION -->
        <b-container fluid v-show="!summaryObjectsExist"  style="padding: 50px;">
          <b-row>
            <b-col md="6" offset-md="3" class="mt-3">
              <b-form-file
                id="file"
                v-model="selectedFile"
                :state="Boolean(selectedFile)"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
                size="lg"
              ></b-form-file>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6" offset-md="3" class="mt-3">
              <div style="float: right; display: inline;">
                <b-button @click="clearPageState">Cancel</b-button>
                <b-button @click="onUpload()" variant="primary" class="ml-1">Upload</b-button>
              </div>
            </b-col>
          </b-row>
        </b-container>
        <!-- END UPLOAD FORM SECTION -->

      <!-- ERROR SECTION -->
      <b-container fluid style="padding-right: 50px; padding-left: 50px;" v-if="error_list.length > 0" >
        <h3>Errors:</h3>
        <!-- <VBUploadObjectsTable :tableData="error_list" :objectName="'Error'" :type="'error'"/> -->
        <VBUploadObjectsContinuousTable :tableData="error_list" :objectName="'Error'" :type="'error'"/>
        <b-row style="margin-bottom: 1rem;">
          <b-col>
            <div style="float: right; display: inline;">
              <b-button @click="clearPageState()">Cancel</b-button>
            </div>
          </b-col>
        </b-row>
      </b-container>

      <!-- SUMMARY SECTION -->
      <b-container fluid style="padding-right: 50px; padding-left: 50px;" v-if="show_summary">
        <h3>Summary:</h3>
        <b-row><b-col><b>Total CSV rows:</b> {{ summary.csv_rows }}</b-col></b-row>
        <b-row><b-col><b>New rows:</b> {{ summary.new_rows }}</b-col></b-row>
        <b-row><b-col><b>New rows in existing datasets:</b> {{ summary.new_rows_existing_datasets }}</b-col></b-row>
        <b-row><b-col><b>Rows already in database:</b> {{ summary.existing_rows }}</b-col></b-row>
        <b-row><b-col><b>Total Datasets in CSV:</b> {{ summary.csv_datasets }}</b-col></b-row>
        <!-- <b-row><b-col><b>New datasets in CSV:</b> {{ summary.new_datasets.join(', ') }}</b-col></b-row> -->
        <b-row><b-col><b>New datasets in CSV:</b> {{ summary.new_dataset_count }}</b-col></b-row>
          <span v-if="summary.unknown_columns.length">
            <b-row style="color: red;">
              <b-col>
                <b>Unrecognized columns in the file that will not be processed:</b> <br>
                {{ summary.unknown_columns.join(', ') }}
              </b-col>
            </b-row>
        </span>
        <b-row>
          <b-col>
            <h4 style="position: absolute; bottom: 0px;">Row Data Summary:</h4>
          </b-col>
          <b-col>
            <b-row>
                <b-col>
                  <div  style="float: right;">
                    New Row: 
                    <div class="color-box" style="background-color: #c3e6cb; border-color: #8fd19e;"></div>
                  </div>
                </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div  style="float: right;">
                  New Row in Exising Dataset: 
                  <div class="color-box" style="background-color: #ffeeba; border-color: #ffdf7e;"></div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div  style="float: right;">
                  Row Already in Database: 
                  <div class="color-box" style="background-color: #f1b0b7; border-color: #8fd19e;"></div>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <VBUploadObjectsContinuousTable :tableData="cptItems" :objectName="'Row Data Summary'" :type="'summary'"/>
        </b-row>
        <!-- <b-table
          ref="table"
          striped 
          hover 
          sticky-header="500px"
          responsive
          selectable
          select-mode='single'
          bordered
          head-variant="light"
          no-border-collapse

          :items="cptItems"
          :fields="fields"
          tbody-tr-class="vt-table-row"
        >
          <template #table-busy>
            <div class="text-danger my-2">
              <b-spinner class="align-left"></b-spinner>
              <strong>&nbsp;Loading...</strong>
            </div>
          </template>
          <template v-slot:head()="field">
              <span :title="field.field.title" style="font-size: small; white-space: nowrap;">
                  {{ field.label }}
              </span>
          </template>
          <template v-slot:cell()="data">
            <span  :title='data.value'>{{ data.value}}</span>
          </template>
        </b-table> -->
        <span v-if = "warning_list.length > 0">
          <h3>Warnings:</h3>
          <!-- <VBUploadObjectsTable :tableData="warning_list" :objectName="'Warning'" :type="'warning'"/> -->
          <VBUploadObjectsContinuousTable :tableData="warning_list" :objectName="'Warning'" :type="'warning'"/>
        </span>
        <div style="margin-bottom: 1rem;">
          <!-- <h4 style="cursor: pointer;" v-b-toggle.collapse-object-summary @click="showObjectSummary = !showObjectSummary"> -->
            <h4 style="cursor: pointer;" @click="showObjectSummary = !showObjectSummary">
            Object Summary:
            <span v-if="showObjectSummary"> [-] </span>
            <span v-else> [+] </span>
          </h4>
          <!-- <b-collapse id="collapse-object-summary"> -->
          <span v-if="showObjectSummary">
            <VBUploadObjectsContinuousTable :tableData="citations_objs" :objectName="'Citation'" :type="'summary'"/>
            <VBUploadObjectsContinuousTable :tableData="contributors_objs" :objectName="'Contributor'" :type="'summary'"/>
            <VBUploadObjectsContinuousTable :tableData="interactor1s_objs" :objectName="'Interactor 1'" :type="'summary'"/>
            <VBUploadObjectsContinuousTable :tableData="interactor2s_objs" :objectName="'Interactor 2'" :type="'summary'"/>
            <VBUploadObjectsContinuousTable :tableData="maintable_objs" :objectName="'Main Table'" :type="'summary'"/>
            <div style="margin:5px;" v-if="!summaryObjectsExist" >
              <h4>Uploaded file contains no new objects.</h4>
            </div>
          </span>
          <!-- </b-collapse> -->
        </div>
        <b-row style="margin-bottom: 1rem;">
          <b-col>
            <div style="float: right; display: inline;">
              <b-button @click="onCancel">Cancel</b-button>
              <b-button @click="onConfirm()" variant="success" class="ml-1">Confirm</b-button>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </VTBaseTemplate>
</template>

<script>
// @ is an alias to /src
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";
import VTBaseTemplate from "@/layouts/VTBaseTemplate.vue";
// import VBUploadObjectsTable from "@/components/tables/VBUploadObjectsTable.vue";
import VBUploadObjectsContinuousTable from "@/components/tables/VBUploadObjectsContinuousTable.vue";
import SubmitInstructions from "@/components/instructions/SubmitInstructions.vue";
export default {
  name: "submit-vectraits",
  mixins: [VTBaseTemplate],
  components: {
    VTBaseTemplate,
    // VBUploadObjectsTable,
    VBUploadObjectsContinuousTable,
    SubmitInstructions
  },
  data(){
    return{
      data: [],
      table_data: [],
      fields: [], // dynamically populated by buildFieldsArray()
      summary: {
        // new_datasets: [],
        new_dataset_count: 0,
        unknown_columns: [],
      },
      show_summary: false,
      selectedFile: null,
      citations_objs: [],
      contributors_objs: [],
      // sourceinfos_objs: [],
      interactor1s_objs: [],
      interactor2s_objs: [],
      // expercond_objs: [],
      // studylocations_objs: [],
      // traitdesc_objs: [],
      maintable_objs: [],
      uploaded_file_id: '',
      error_list: [],
      warning_list: [],
      err_msg: '',
      apiErrModalShow: false,
      uploadCancelModal: false,
      workingModalShow: false,
      showObjectSummary: false,
    };
  },
  computed: {
    summaryObjectsExist: function () {
      // return true if there are any elements in any of the object lists
      let summaries = [
        this.citations_objs,
        this.contributors_objs,
        // this.sourceinfos_objs,
        this.interactor1s_objs,
        this.interactor2s_objs,
        // this.expercond_objs,
        // this.studylocations_objs,
        // this.traitdesc_objs,
        this.maintable_objs,
      ]
      return summaries.some((array) => array.length != 0);
    },
    cptItems(){
      // add formatting to the row items based on the value in the RowUploadStatus column
      return this.table_data.map((item)=>{
        let tmp=item;
        if (item.RowUploadStatus == "New row"){
          tmp._rowVariant='success';
        } else if (item.RowUploadStatus == "New row in existing dataset"){
          tmp._rowVariant='warning';
        } else if (item.RowUploadStatus == "Row already exists"){
          tmp._rowVariant='danger';
        }
        return tmp;
      })  
    }
  },
  watch: {},
  created() {
    document.title = "Submit VecTraits Data";
  },
  methods: {
    hideModal() {
      this.apiErrModalShow = false;
      this.uploadCancelModal = false;
    },
    onFileSelected: function (event) {
      this.selectedFile = event.target.files[0];
    },
    onCancel: function(){
      this.err_msg = "Are you sure you would like to cancel the file upload process?"
      this.uploadCancelModal = true;
    },
    cancelFileUpload: function(){
      HTTP.delete(`/api/vectraits-file-delete/${this.uploaded_file_id}`)
      .then((response) => {
        this.clearPageState()
        this.uploadCancelModal = false;
        this.$notify({
          text: response.data.message,
          duration: 10000,
          type: "success",
        });
      }).catch((error) => {
        this.err_msg = HandleErrors.HandleErrors(error);
        this.apiErrModalShow = true;
        this.workingModalShow = false
      });
    },
    clearPageState: function () {
      this.table_data = [];
      this.fields = [];

      // this.summary.new_datasets = [];
      this.summary.new_dataset_count = 0;
      this.summary.unknown_columns = [];

      this.show_summary = false;
      this.showObjectSummary = false;

      this.citations_objs = [];
      this.contributors_objs = [];
      // this.sourceinfos_objs = [];
      this.interactor1s_objs = [];
      this.interactor2s_objs = [];
      // this.expercond_objs = [];
      // this.studylocations_objs = [];
      // this.traitdesc_objs = [];
      this.maintable_objs = [];
      this.uploaded_file_id = '';
      this.selectedFile = null;
      this.error_list = [];
      this.warning_list = [];
      this.err_msg = '';
    },
    onUpload: function () {
      const that = this;
      if (!this.selectedFile) {
        return that.$bvModal.msgBoxOk("Please select a file!", {
        title: "File Error",
        okVariant: "danger",
        centered: true,
        });
      }
      this.workingModalShow = true;
      const fd = new FormData();
      fd.append("file", this.selectedFile, this.selectedFile.name);
      //HTTP.post("/api/vectraits-stage/", fd)
      HTTP.post("/api/vectraits-naive-stage/", fd)
      .then(response => {
        this.table_data = response.data.records;
        this.fields = this.buildFieldsArray(this.table_data);
        this.summary = response.data.summary;
        this.citations_objs = response.data.citations_list;
        this.contributors_objs = response.data.contributors_list;
        // this.sourceinfos_objs = response.data.sourceinfos_list;
        this.interactor1s_objs = response.data.interactor1s_list;
        this.interactor2s_objs = response.data.interactor2s_list;
        // this.expercond_objs = response.data.experconditions_list;
        // this.studylocations_objs = response.data.studylocations_list;
        // this.traitdesc_objs = response.data.traitdescriptions_list;
        this.maintable_objs = response.data.maintables_list;
        this.uploaded_file_id = response.data.file_upload_id;
        this.error_list = response.data.error_list;
        this.warning_list = response.data.warning_list;
        this.show_summary = true;
        this.workingModalShow = false
        this.$notify({
          text: "File successfully uploaded!",
          duration: 10000,
          type: "success",
        });
      })
      .catch((error) => {
        this.err_msg = HandleErrors.HandleErrors(error);
        this.apiErrModalShow = true;
        this.workingModalShow = false
      });
      
    },
    buildFieldsArray(data) {
      // Gets called by the onUpload() method. Build the fields array which is used by the main b-table.

      // NOTE: IF THERE ARE NO ROWS IN DATA, THIS WILL ERROR OUT.
      // TODO: handle no rows in input. Currently, we are checking that there are rows before calling this
      // function in myProvider().

      // convert each element to an object containing the field name as a key, a sortable key, and tdclass:
      // ie. convert "OriginalID" to 
      // "{ key: 'OriginalID', sortable: true, tdClass: 'text-truncate vt-table-cell' },"
      let field_list = Object.keys(data[0]);

      let field_array = [];

      field_list.forEach(function(fieldName) {
          let field_dict = {};
          field_dict['key'] = fieldName;
          field_dict['sortable'] = true;
          field_dict['tdClass'] = 'text-truncate vt-table-cell';
          field_dict['__rowVariant'] = 'danger';

          field_array.push(field_dict);
      });

      return field_array;
    },
    onConfirm: function () {
      // Inform the backend that the user is happy with the file. The endpoint will do a final check of the file and 
      // then switch the status to "Confirmed" which will let a curator know that the file is ready for ingestion.
      const that = this;

      const fd = new FormData();
      fd.append("uploaded_file_id", this.uploaded_file_id);

      HTTP.post("/api/vectraits-confirm/", fd)
      .then(response => { 
        this.err_msg = response.data.err_msg;
        that.selectedFile = null;
        this.$notify({
          text: "File successfully processed!",
          duration: 10000,
          type: "success",
      });
      })
      .catch((error) => { // executes whenever there is a response that is not a 200
        this.err_msg = HandleErrors.HandleErrors(error);
        this.apiErrModalShow = true;
      });
      this.clearPageState();
    },
    downloadTemplate(){
      // build the params object to be sent with the request.
      var params = new URLSearchParams();
      // params.append(<KEY>, <VALUE>)

      var request = {
        params: params,
        responseType: "arraybuffer",
      };

      HTTP.get(`/api/vectraits-template-download/`, request)
      .then((response) => {
        var fileURL = window.URL.createObjectURL(
          new Blob([response.data])
        );
        var fileLink = document.createElement("a");
        fileLink.href = fileURL;
        var fileName = "vectraits_template.csv";
        fileLink.setAttribute("download", fileName);
        document.body.appendChild(fileLink);
        fileLink.click();
      })
      .catch((error) => {
        this.err_msg = HandleErrors.HandleErrors(error);
        this.apiErrModalShow = true;
      });
    },
  },
  beforeRouteLeave (to, from , next) {
    if (this.table_data.length > 0) {
      const answer = window.confirm('Do you really want to leave? You have not confirmed your file upload.')
      if (answer) {
        HTTP.delete(`/api/vectraits-file-delete/${this.uploaded_file_id}`)
          .then(() => {
            this.clearPageState()
            this.uploadCancelModal = false;
          }).catch((error) => {
            this.err_msg = HandleErrors.HandleErrors(error);
            this.apiErrModalShow = true;
            this.workingModalShow = false
          });
        next()
      } else {
        next(false)
      } 
    }else{
      next()
    }
  }
};
</script>

<style scoped>
  .table-head {
    background: #777;
    font-weight: bold;
    text-align: left;
    padding: 5px;
  }

  .btn-success {
    background: var(--vb_green)
  }
</style>